<template>
  <div class="card card-default book-list">
    <div class="card-body">
      <sch-text label="검색어" :data="data" @search="search(1)" />

      <span class="text-bold h4">회원 목록</span>
      <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="2%" style="text-align:center"><input type="checkbox" v-model="data.selectAllMember" /></td>
              <td width="3%" style="text-align:center">No</td>
              <td width="8%" style="text-align:center" >회원유형</td>
              <td width="10%" style="text-align:center" @click="localSort.sort('loginId')">ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="10%" style="text-align:center" @click="localSort.sort('name')">이름<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="5">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center"><input type="checkbox" v-model="data.selectedMembers" :value="item.loginId" /></td>
                <td class="align-middle text-center">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center">{{userTypeOption.getUserTypeText(item.typeCd)}}</td>
                <td class="align-middle text-center">{{item.maskedLoginId}}</td>
                <td class="align-middle text-center">{{item.name}}</td>
              </tr>
            </template>
          </tbody>
        </table>
    </div>
    <div class="card-footer">
      <div class="d-flex">
        <!--paging component-->
        <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
      </div>
      <div class="card-tool float-right">
        <b-button @click="save()" :disabled="!data.enabledApply" class="btn btn-sm mr-2" variant="outline-info">확인</b-button>
        <b-button @click="close()" class="btn btn-sm mr-2" variant="outline-info">취소</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api';
import {dataObject, ValueTexts, userTypeCd} from "@/utils/Constants";
import * as memberApi from "@/api/mem/MemberAPI";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";

export default {
  components: {SchText, ShowCounter, Pagenation},
  props: {
  },
  setup(props, context) {
    const _dataObject = _.cloneDeep(dataObject);
    _dataObject.schOptions = [
        {value:'loginId', text:'회원 ID'},
        {value:'name', text:'이름'},
    ];
    _dataObject.selectedMembers = [];
    _dataObject.selectAllMember = computed({
      get() {
        return data.list.length ? data.selectedMembers.length == data.list.length : false;
      },
      set(newValue) {
        let selected = [];
        if (newValue) {
          data.list.forEach(item => {
            selected.push(item.loginId);
          });
        }
        data.selectedMembers = selected;
      }
    });
    _dataObject.enabledApply = computed(() => {
      return data.selectedMembers.length > 0;
    })
    const data = reactive(_dataObject);

    const retVals = {
      userTypeOption: new ValueTexts(userTypeCd),
      data,
      ...methods(props, data, context),
      dataAction: new TableActionClass(data),
      localSort:context.root.$_localSort
    };

    onMounted(async () => {
      await retVals.search();
    });

    return retVals;
  }
}

function methods(props, data, context) {
  async function search(page) {
    data.selectedMembers.splice(0, data.selectedMembers.length);

    if (!isNaN(page)) {
      data.params.page = page;
    }
    
    const result = await memberApi.getUserList(data.params);
    data.list = result.data;
    data.count = result.count;
    this.localSort.set(data.list);
  }

  async function save() {
    const selectedMembers = data.list.filter((member) => data.selectedMembers.includes(member.loginId));
    context.emit('save', selectedMembers);
  }

  async function close() {
    context.emit('close');
  }

  return {
    search,
    save,
    close,
  }
}
</script>